var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-10 col-xl-8"},[_c('block-activity',{ref:"block-activity",attrs:{"activity":_vm.activity},on:{"loadActivity":_vm.loadActivity,"loadImages":_vm.loadImages,"loadFiles":_vm.loadFiles}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }